import {
  clearStableRequest,
  getBrowserStorage,
  getOrCreateStableRequest,
} from '../../../../services/stableRequestId'

const CONFIRM_PREFIX = 'specific:planet-hd-confirm'
const PREPARE_PREFIX = 'specific:planet-hd-prepare'
const getSessionStorage = () => getBrowserStorage('sessionStorage')

export const getOrCreatePlanetHdConfirmRequest = (
  {companyId, companyPeriodId, geometryHash, landId, product},
  storage = getSessionStorage(),
  createId
) => getOrCreateStableRequest(
  CONFIRM_PREFIX,
  {companyId, geometryHash, landId, product, ...(companyPeriodId ? {companyPeriodId} : {})},
  storage,
  createId
)

export const getOrCreatePlanetHdPrepareRequest = (
  {accessId, companyPeriodId, acquisitionId, geometryHash, landId, layer},
  storage = getSessionStorage(),
  createId
) => getOrCreateStableRequest(
  PREPARE_PREFIX,
  {
    accessId,
    acquisitionId,
    geometryHash,
    landId,
    layer,
    ...(companyPeriodId ? {companyPeriodId} : {}),
  },
  storage,
  createId
)

export const clearPlanetHdRequest = (storageKey, storage = getSessionStorage()) => {
  clearStableRequest(storageKey, storage)
}
